import eventbus from '../../utils/eventbus';
import { formatTime } from '../../utils/intl';

const DIRECTION_UP = 'up';
const DIRECTION_DOWN = 'down';

class TickerCompare {
	constructor(el, { isin, underlyingKey, feedProperty, direction, value = 0 } = {}) {
		this.el = el;
		this.id = isin || underlyingKey;

		this.feedProperty = feedProperty;
		this.direction = direction;
		this.value = value;

		this.valueEl = this.el.querySelector('[data-ref="value"]');
		this.dateTimeEl = this.el.querySelector('[data-ref="datetime"]');

		this.onTick = this.onTick.bind(this);

		this.start();
	}

	get hasDateTimeEl() {
		return this.dateTimeEl !== null;
	}

	start() {
		if (!this.valueEl) {
			console.warn('A value element is missing');

			return;
		}

		if (!this.direction) {
			console.warn('Direction is missing');

			return;
		}

		if (this.direction !== DIRECTION_UP && this.direction !== DIRECTION_DOWN) {
			console.warn(`Direction ("${this.direction}") should be either '${DIRECTION_UP}' or '${DIRECTION_DOWN}'`);

			return;
		}

		eventbus.on(`tick:${this.id}`, this.onTick);
	}

	destroy() {
		eventbus.off(`tick:${this.id}`, this.onTick);
	}

	onTick(tick) {
		this.update(tick);
	}

	update(tick) {
		const newValue = tick[this.feedProperty];
		const shouldUpdate = TickerCompare.shouldUpdate(this.value, newValue, this.direction);

		if (!shouldUpdate) {
			return;
		}

		this.updateValue(tick);
		this.updateDateTime();
	}

	updateValue(tick) {
		const value = tick[this.feedProperty];
		const valueFormatted = tick[`${this.feedProperty}Formatted`];
		const valueDisplay = valueFormatted || value;

		this.valueEl.textContent = valueDisplay;

		this.value = value;
	}

	updateDateTime() {
		if (!this.hasDateTimeEl) {
			return;
		}

		const dateTimeFormatted = formatTime(new Date());

		this.dateTimeEl.textContent = dateTimeFormatted;
	}

	static shouldUpdate(oldValue, newValue, direction) {
		if (!oldValue) {
			return true;
		}

		if (direction === DIRECTION_UP && newValue > oldValue) {
			return true;
		}

		if (direction === DIRECTION_DOWN && newValue < oldValue) {
			return true;
		}

		return false;
	}
}

export default TickerCompare;
